import React from "react";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";

export default function BillingRenewalTab() {
  const subscription = {
    status: "Active",
    interval: "Monthly",
    renewalDate: "March 1, 2025",
    licenses: 12,
  };

  return (
    <Box sx={{ p: 2, display: "grid", gap: 2 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Renewal
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Your subscription will auto renew on the date shown below.
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ p: 2, display: "grid", gap: 1.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Subscription Summary
        </Typography>
        <Divider />
        <Box sx={{ display: "grid", gap: 0.5 }}>
          <Typography variant="body2">
            Status: <strong>{subscription.status}</strong>
          </Typography>
          <Typography variant="body2">
            Billing Interval: <strong>{subscription.interval}</strong>
          </Typography>
          <Typography variant="body2">
            Licenses: <strong>{subscription.licenses}</strong>
          </Typography>
          <Typography variant="body2">
            Next Renewal Date: <strong>{subscription.renewalDate}</strong>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Button variant="contained" color="primary" disabled>
            Manage Subscription
          </Button>
          <Button variant="outlined" color="error" disabled>
            Cancel Subscription
          </Button>
        </Box>
        <Typography variant="caption" sx={{ opacity: 0.6 }}>
          Monthly or annual billing options will surface here once subscription data is wired in.
        </Typography>
      </Paper>
    </Box>
  );
}
